<app-card-table
    #serviceGroups
    [tableKey]="'serviceGroups' + groupType()"
    [tableTitle]="'service.settings.group.label' + groupTypeSuffix()"
    [columns]="columns()"
    translatePrefix="service.settings.group."
    [hideCheckboxes]="true"
    [additionalFilter]="additionalFilter()"
    [gridData]="$any(store.data.getServiceGroups())"
    [refreshCallback]="store.api.getServiceGroups"
    [defaultSorters]="[{ column: 'createdAt', direction: 'DESC' }]"
    (createCallback)="openDialog()"
    (detailCallback)="openDialog($event)"
    (deleteCallbackWithEvent)="deleteGroup($event)"
    [refreshCallbackFragment]="groupType() === ServiceGroupEnum.OFFERS ? serviceOfferGroupItemFrag : serviceGroupItemFrag"
></app-card-table>
